var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { BaseBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
var handleHeadingType = function (props) {
    switch (props.$fontWeight) {
        case 'bold':
            return 'bold';
        case 'bolder':
            return 800;
        case 'medium':
            return 500;
        default:
            return props.$fontWeight || 'inherit';
    }
};
var handleType = function (props) {
    return "\n  font-size: " + props.theme.v2.typography[props.$type][props.$tag].size + ";\n  line-height: " + props.theme.v2.typography[props.$type][props.$tag].lineHeight + ";\n  color: " + (props.color || props.theme.v2.colors[props.$type]) + ";\n  ";
};
var StyledHeading = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  letter-spacing: inherit;\n  font-weight: ", ";\n  ", ";\n"], ["\n  letter-spacing: inherit;\n  font-weight: ", ";\n  ", ";\n"])), function (props) { return handleHeadingType(props); }, function (props) { return handleType(props); });
function Heading(_a) {
    var showTooltipTitle = _a.showTooltipTitle, title = _a.title, tag = _a.tag, tagAs = _a.tagAs, type = _a.type, fontWeight = _a.fontWeight, children = _a.children, onClick = _a.onClick, props = __rest(_a, ["showTooltipTitle", "title", "tag", "tagAs", "type", "fontWeight", "children", "onClick"]);
    if (!(children || title))
        return null;
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(StyledHeading, __assign({ as: tagAs ? tagAs : type === 'heading' ? tag : 'div', "$tag": tag, "$type": type, "$fontWeight": fontWeight, onClick: onClick }, props), children || title)));
}
var Heading1 = styled(Heading).attrs(function () { return ({ tag: 'h1', type: 'heading' }); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Heading2 = styled(Heading).attrs(function () { return ({ tag: 'h2', type: 'heading' }); })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Heading3 = styled(Heading).attrs(function () { return ({ tag: 'h3', type: 'heading' }); })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var Heading4 = styled(Heading).attrs(function () { return ({ tag: 'h4', type: 'heading' }); })(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var Body1 = styled(Heading).attrs(function () { return ({ tag: 'body1', type: 'body' }); })(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var Body2 = styled(Heading).attrs(function () { return ({ tag: 'body2', type: 'body' }); })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
export { Heading, Heading1, Heading2, Heading3, Heading4, Body1, Body2 };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
